<template>
    <rkm-overlay>
        <template v-if="!cboValido">
            <rkm-layout-body title="Acolhimento Saúde Bucal">
                <rkm-alert color="warning">
                    CBO do usuário inválido. A funcionalidade deve ser acessada somente com os seguintes CBOs:
                    <strong>{{ cbosPermitidosDescricao }}</strong>.
                </rkm-alert>
            </rkm-layout-body>
        </template>

        <template v-else-if="[enums.setorTipo.SAUDE_BUCAL].includes(centroCusto.setor.tipoId)">
            <rkm-layout-body title="Acolhimento Saúde Bucal">
                <rkm-layout-content>
                    <List @data-load="data = $event" />
                </rkm-layout-content>
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body title="Acolhimento Saúde Bucal">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>SAÚDE BUCAL</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/acolhimento-saude-bucal/List'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'
import ocupacaoCodigo from '@/enums/sigtap/ocupacao'

// Vuex.
import {mapGetters} from 'vuex'

const cboPermitido = [
    {codigo: ocupacaoCodigo.TECNICO_EM_SAUDE_BUCAL, nome: 'Técnico em Saúde Bucal'},
    {codigo: ocupacaoCodigo.TECNICO_EM_SAUDE_BUCAL_ESF, nome: 'Técnico em Saúde Bucal da ESF'},
    {codigo: ocupacaoCodigo.AUXILIAR_EM_SAUDE_BUCAL, nome: 'Auxiliar em Saúde Bucal'},
    {codigo: ocupacaoCodigo.AUXILIAR_EM_SAUDE_BUCAL_ESF, nome: 'Auxiliar em Saúde Bucal'},
]

export default {
    components: {List},
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto', lotacao: 'getLotacao'}),
        cboValido() {
            return cboPermitido.some(cbo => cbo.codigo === this.lotacao.ocupacao.codigo)
        },
        cbosPermitidosDescricao() {
            return cboPermitido.map(cbo => `${cbo.codigo} - ${cbo.nome}`).join(', ')
        },
    },

    data: () => ({
        data: null,
        enums: {setorTipo},
    }),
}
</script>